module.exports = __webpack_public_path__ + "static/017.thumb-322bbf5a6eee1944f3a60e6ac688b4f4.jpg";